import "../../styles/loader.css";

export const LoadingIndicator = () => {
    return (
        <div className="white-bg flx-col c-al c-jt">
            <div className="loader">
                <img src="/act-color.png" className="loader-img" alt="" />
            </div>
        </div>
    )
}